export class Card {
  public number: number;
  public exp_month: number;
  public exp_year: number;
  public cvc: number;

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/card.ts